import { auth } from "@/services";

angular.module("app").controller("adminPagesController", adminPagesController);

adminPagesController.$inject = [
  "alerts",
  "PagesApi",
  "Pages",
  "SettingsApi",
  "handleError",
  "siteSettings",
];

function adminPagesController(
  alerts,
  PagesApi,
  Pages,
  SettingsApi,
  handleError,
  siteSettings,
) {
  const vm = this;
  const user = auth.user();

  // properties
  vm.isLoading = true;
  vm.page = 1;
  vm.sort = "created_at";
  vm.order = "desc";
  vm.pages = {};
  vm.page_size = 15;
  vm.permissionChecks = {
    // TODO: move to a site settings policy
    canManageHeaderLinks: user && user.hasPermission("sites.set.settings"),
  };
  vm.template = {
    link: {
      label: "Link",
      type: "string",
      placeholder: "http://",
    },
    label: {
      label: "Title",
      type: "string",
      placeholder: "Link text",
    },
  };
  vm.settings = angular.copy(siteSettings);
  vm.systemPageSlugs = [
    "faq",
    "members",
    "events",
    "promotions",
    "polls",
    "news",
  ];
  // !TODO: This should be provided by the backend
  // vm.systemPages = [
  //     'resources',
  //     'forum',
  //     'news',
  //     'packages',
  //     'faq',
  //     'members',
  //     'events',
  //     'promotions',
  //     'polls',
  // ];

  // methods
  vm.getPages = getPages;
  vm.editPage = editPage;
  vm.createPage = createPage;
  vm.saveSettings = saveSettings;

  /**
   * Retrieves pages from the api and adds to scope
   * @return {void}
   */
  function getPages() {
    vm.isLoading = true;
    PagesApi.get(
      {
        page: vm.page,
        page_size: vm.page_size,
      },
      function (response) {
        vm.pages = response;
        vm.isLoading = false;
      },
      function (err) {
        handleError(err);
        vm.isLoading = false;
      },
    );
  }

  /**
   * Edits the page via a modal, and updates model in this controller
   * @param  {int} pageId - ID of page to edit
   * @return {void}
   */
  function editPage(pageId) {
    Pages.edit(pageId).result.then(
      function (updatedPage) {
        // Find and update the page
        angular.forEach(vm.pages.data, function (page, index) {
          if (page.id === updatedPage.id) {
            vm.pages.data[index] = updatedPage;
          }
        });
      },
      function (action) {
        if (action === "deleted") {
          getPages();
        }
      },
    );
  }

  /**
   * Save the "page links" specific settings.
   *
   * @return {void}
   */
  function saveSettings() {
    SettingsApi.save(
      {
        settings: {
          links_header: vm.settings.links_header,
          links_footer: vm.settings.links_footer,
        },
      },
      handleSuccess,
      function (resp) {
        vm.isLoading = false;
        vm.formErrors = resp.data;
      },
    ).suppressValidationAlerts();

    function handleSuccess() {
      vm.isLoading = false;
      alerts.emit({
        theme: "success",
        title: "Settings Saved",
        messages: [],
      });
    }
  }

  /**
   * Creates a page then refreshes pages
   * @return {void}
   */
  function createPage() {
    Pages.create().result.then(function () {
      getPages();
    });
  }

  getPages();
}
